/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Priority_DescriptionInputs */



/**
* | output |
* | --- |
* | "When answering questions, the AI will prefer information from your linked knowledge spaces over its general training data." |
*
* @param {Rag_Priority_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_priority_description = /** @type {((inputs?: Rag_Priority_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Priority_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei der Beantwortung von Fragen bevorzugt die KI Informationen aus den verlinkten Wissensspaces gegenüber dem allgemeinen Trainingswissen.")
	return /** @type {LocalizedString} */ ("When answering questions, the AI will prefer information from your linked knowledge spaces over its general training data.")
});